import * as React from 'react';
import { FC } from 'react';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { Values, ChangeValues } from './types';

const Terms: FC<{
  values: Values;
  changeValues: ChangeValues;
  locales: Locales;
}> = ({ values, changeValues, locales }) => (
  <div className="input boolean player_terms xo-form_input-checkbox">
    <input
      type="checkbox"
      checked={values.terms}
      onChange={() => changeValues({ terms: !values.terms })}
      name="player[terms]"
      id="player_terms"
    />
    <label htmlFor="player_terms">
      <span dangerouslySetInnerHTML={{ __html: translation(locales, 'attributes.terms') }} />
    </label>
  </div>
);

export default Terms;
